export const PUSH_DRAWER_ARIA_CONTROLS_ID = 'provider-push-drawer';
export const PAYOR_NO_SAME_DAY_HEADER = 'Update appointment to avoid billing issue';
export const CONFLICT_HEADER = 'Resolve scheduling conflict';
export const PATIENT_OVERLAP_WITH_DIFFERENT_PROVIDERS_HEADER = 'Please choose a different date or time';
export const IMPROBABLE_DAYS_HEADER = 'Review your schedule';
